import React, { useMemo } from "react";

import PinLegend from "@mapmycustomers/shared/types/map/PinLegend";

import PinLegendLabel from "../components/PinLegendLabel";

const usePinLegendOptions = (pinLegends: PinLegend[], onEdit?: (pinLegend: PinLegend) => void) =>
  useMemo(
    () =>
      pinLegends.map((legend) => ({
        filterLabel: legend.name,
        label: <PinLegendLabel onEdit={onEdit} pinLegend={legend} />,
        value: legend.id,
      })),
    [onEdit, pinLegends]
  );

export default usePinLegendOptions;
